import noop from 'lodash/noop';
import memoizeOne from 'memoize-one';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import type { RealtimeEvent } from '@atlassian/jira-realtime/src/common/types/events.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import Realtime from '@atlassian/jira-realtime/src/main.tsx';
import { APP_ID } from '../../model/constants.tsx';
import { REALTIME_EVENTS } from '../../model/realtime/constants.tsx';
import { dispatchRealtimeEvent } from '../../state/actions/realtime/index.tsx';
import type { State } from '../../state/reducers/types.tsx';
import { isCustomFiltersActive } from '../../state/selectors/filter/custom-filter-selectors.tsx';
import { realtimeChannelSelector } from '../../state/selectors/realtime/realtime-selectors.tsx';
import {
	cloudIdSelector,
	currentUserAccountIdSelector,
	getIsCMPBoard,
	projectIdSelector,
	rapidViewIdSelector,
} from '../../state/selectors/software/software-selectors.tsx';
import { isJqlFilterActive } from '../../state/selectors/work/work-selectors.tsx';

type StateProps = {
	isCustomFiltersActive: boolean;
	isJqlFilterActive: boolean;
	cloudId: string;
	projectId: number;
	currentUserId: string;
	boardId: string;
	channels: string[];
	isCMPBoard: boolean;
};

const mapStateToProps = (state: State) => ({
	cloudId: cloudIdSelector(state),
	projectId: projectIdSelector(state),
	boardId: rapidViewIdSelector(state),
	channels: realtimeChannelSelector(state),
	currentUserId: currentUserAccountIdSelector(state),
	// If custom filters or JQL are active on this board, we actually need to listen to the granular
	// issue create and issue update events since BSI updated event does not give us enough context
	isCustomFiltersActive: isCustomFiltersActive(state),
	isJqlFilterActive: isJqlFilterActive(state),
	isCMPBoard: getIsCMPBoard(state),
});

const mapDispatchToProps = {
	createRealtimeEventAction: dispatchRealtimeEvent,
} as const;

type DispatchProps = typeof mapDispatchToProps;
const onReceiveFactory = memoizeOne(
	(createRealtimeEventAction: DispatchProps['createRealtimeEventAction']) =>
		(event: RealtimeEvent) => {
			if (event) {
				createRealtimeEventAction(event);
			}
		},
);

export const mergeProps = (stateProps: StateProps, dispatchProps: typeof mapDispatchToProps) => {
	return {
		appId: APP_ID,
		channels: stateProps.channels,
		events: REALTIME_EVENTS,
		onJoin: noop,
		onReceive: onReceiveFactory(dispatchProps.createRealtimeEventAction),
		onLeave: noop,
	};
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Realtime);
